// The single source of truth for which theme options are reported to analytics on embed load.
//
// Kept in this DEPENDENCY-FREE leaf module (no imports at all) on purpose: consumers that only need the key
// set — notably the bi-mcp analytics catalog, which derives its `describe_analytics` option lists from these
// — can import it without pulling the zod theme-config graph that liveblog.ts / teaser.ts carry. The build-
// time guard that a renamed/removed option is a compile error stays next to the config types: liveblog.ts and
// teaser.ts feed these arrays through `Pick<…ThemeConfiguration, typeof <keys>[number]>`, so a key that is not
// an option on the resolved config fails to type-check there. Adding an option here is the only step needed to
// start tracking it; the collector and every downstream stage are schemaless (opaque strings), so nothing else
// re-declares these keys. Deliberately excludes the free-form color options (high cardinality, not a "setting").

export const analyticsLiveblogThemeKeys = [
  "layout",
  "layoutAuthorPosition",
  "layoutEventTagPosition",
  "refresh",
  "sort",
  "sortControls",
  "sharing",
  "commentsMode",
  "highlightSummaryType",
  "styleUseCards",
  "useSlideshow",
  "sportsShowScoreboard",
  "sportsShowScorerList",
  "dateTimeDisplay",
  "eventTagNavigation",
  "webEmbedDefaultConstraint",
  "injectSchemaOrg"
] as const

// The teaser widget has its own, smaller theme model, so its tracked subset is separate from the liveblog one.
export const analyticsTeaserThemeKeys = [
  "layout",
  "layoutLiveIndicatorStyle",
  "layoutLiveblogLink",
  "layoutTimeline",
  "showTitle",
  "styleInvertTime",
  "layoutWhenScoreboard",
  "content",
  "limit"
] as const
